// @flow
import { PrivacyPolicyActionTypes } from './constants';

type PrivacyPolicyAction = { type: string, payload: {} | string };

// common success
export const privacyPolicyApiResponseSuccess = (actionType: string, data: any): PrivacyPolicyAction => ({
    type: PrivacyPolicyActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const privacyPolicyApiResponseError = (actionType: string, error: string): PrivacyPolicyAction => ({
    type: PrivacyPolicyActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const updatePrivacyPolicy = (privacyPolicy: any): PrivacyPolicyAction => ({
    type: PrivacyPolicyActionTypes.UPDATE_PRIVACY_POLICY,
    payload: privacyPolicy
})

export const resetPrivacyPolicy = (): PrivacyPolicyAction => ({
    type: PrivacyPolicyActionTypes.RESET,
    payload: {},
});

